import Vue from 'vue'
import Dialog from './dialog.vue'
import { defaultValue } from './data'

const _Constructor = Vue.extend(Dialog)

let instance

const show = (opts) => {  
  if (!instance) {
    instance = new _Constructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
  
  const defaultOpts = {...defaultValue, ...opts}
  defaultOpts.visible = true
  for (const key in defaultOpts) {
    if (Object.hasOwnProperty.call(defaultOpts, key)) {
      instance[key] = defaultOpts[key]
    }
  }
}

const hide = () => {
  if (instance) {
    instance.visible = false
  }
}

export default {
  install(Vue) {
    Vue.prototype.lyfDialog = show
    Vue.prototype.lyfHideDialog = hide
  }
}